import React, { Suspense, lazy } from "react";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import LoadPage from "./resource/pages/LoadPage.tsx";

// Code splitting using React.lazy
const HomePage = lazy(() => import("./resource/pages/Home.tsx"));
const ValuePage = lazy(() => import("./resource/pages/Value.tsx"));
const LecturerPage = lazy(() => import("./resource/pages/Lecturer.tsx"));
const HistoryPage = lazy(() => import("./resource/pages/History.tsx"));
const StaffPage = lazy(() => import("./resource/pages/Staff.tsx"));
const OrgantizationalStructurePage = lazy(
  () => import("./resource/pages/OrganizationalStructure.tsx")
);
const FaculityLeaderPage = lazy(
  () => import("./resource/pages/FaculityLeader.tsx")
);
const IntegrityZone = lazy(() => import("./resource/pages/IntegrityZone.tsx"));
const WBSPage = lazy(() => import("./resource/pages/WBS/WBSPage.tsx"));
const ResearchPage = lazy(() => import("./resource/pages/Research.tsx"));
const AchievementPage = lazy(() => import("./resource/pages/Achievement.tsx"));
const BooksPage = lazy(() => import("./resource/pages/Books.tsx"));
const DevotionPage = lazy(() => import("./resource/pages/Devotion.tsx"));
const AlumniPage = lazy(() => import("./resource/pages/Alumni.tsx"));
const AlumniAchievementPage = lazy(
  () => import("./resource/pages/AlumniAchievement/AlumniAchievement.tsx")
);
const DetailAlumniAchievementPage = lazy(
  () => import("./resource/pages/AlumniAchievement/Detail.tsx")
);
const JobVacancyPage = lazy(
  () => import("./resource/pages/JobVacancy/JobVacancy.tsx")
);
const DetailJobVacancyPage = lazy(
  () => import("./resource/pages/JobVacancy/Detail.tsx")
);
const AcademicCalendarPage = lazy(
  () => import("./resource/pages/AcademicCalendar.tsx")
);
const DetailAcademicCalendarPage = lazy(
  () => import("./resource/pages/DetailAcademicCalendar.tsx")
);
const KEPKInformationPage = lazy(
  () => import("./resource/pages/KEPKInformation.tsx")
);
const AboutFacultyQualityPage = lazy(
  () => import("./resource/pages/AboutFacultyQuality.tsx")
);

const RTMPage = lazy(() => import("./resource/pages/RTM.tsx"));
const InternalAuditQualityPage = lazy(
  () => import("./resource/pages/InternalAuditQuality.tsx")
);
const AccreditationCriteriaPage = lazy(
  () => import("./resource/pages/AccreditationCriteria.tsx")
);
const TheaterRoomPage = lazy(() => import("./resource/pages/TheaterRoom.tsx"));
const MosquePage = lazy(() => import("./resource/pages/Mosque.tsx"));
const SmartClassroomPage = lazy(
  () => import("./resource/pages/SmartClassroom.tsx")
);
const LibraryPage = lazy(() => import("./resource/pages/Library.tsx"));
const FarmacyStudyRoomPage = lazy(
  () => import("./resource/pages/FarmacyStudyRoom.tsx")
);
const NewsPage = lazy(() => import("./resource/pages/News/News.tsx"));
const DetailNewsPage = lazy(() => import("./resource/pages/News/Detail.tsx"));
const AnnouncementPage = lazy(
  () => import("./resource/pages/Announcement/Announcement.tsx")
);
const DetailAnnouncementPage = lazy(
  () => import("./resource/pages/Announcement/Detail.tsx")
);
const AgendaPage = lazy(() => import("./resource/pages/Agenda/Agenda.tsx"));
const GalleryPage = lazy(() => import("./resource/pages/Gallery.tsx"));
const ProgramPage = lazy(() => import("./resource/pages/Program/Program.tsx"));
const DetailProgramPage = lazy(
  () => import("./resource/pages/Program/Detail.tsx")
);
const LibraryInfoPage = lazy(
  () => import("./resource/pages/Library/Library.tsx")
);
const AvailableInfoPage = lazy(
  () => import("./resource/pages/PPID/AvailableInfo.tsx")
);
const ExcludedInfoPage = lazy(
  () => import("./resource/pages/PPID/ExcludedInfo.tsx")
);
const NecessarilyInfoPage = lazy(
  () => import("./resource/pages/PPID/NecessarilyInfo.tsx")
);
const ObligatoryInfoPage = lazy(
  () => import("./resource/pages/PPID/ObligatoryInfo.tsx")
);
const RegulationInfoPage = lazy(
  () => import("./resource/pages/PPID/RegulationInfo.tsx")
);
const Laboratorium = lazy(
  () => import("./resource/pages/Laboratorium/Laboratorium.tsx")
);
const SchoolarshipPage = lazy(() => import("./resource/pages/Scholarship.tsx"));
const CounselingPage = lazy(() => import("./resource/pages/Counseling.tsx"));
const StudentServicePage = lazy(
  () => import("./resource/pages/StudentServices/Index.tsx")
);
const EmployeeServicePage = lazy(
  () => import("./resource/pages/EmployeeServices/Index.tsx")
);
const ActiveStudyStepPage = lazy(
  () => import("./resource/pages/StudentServices/ActiveStudyStep.tsx")
);
const StudyLetterStepPage = lazy(
  () => import("./resource/pages/StudentServices/StudyLetterStep.tsx")
);
const TranscriptStepPage = lazy(
  () => import("./resource/pages/StudentServices/TranscriptStep.tsx")
);
const SKLClinicStepPage = lazy(
  () => import("./resource/pages/StudentServices/SKLClinicStep.tsx")
);
const ScholarshipStepPage = lazy(
  () => import("./resource/pages/StudentServices/ScholarshipStep.tsx")
);
const SKLGeneralStepPage = lazy(
  () => import("./resource/pages/StudentServices/SKLGeneralStep.tsx")
);
const DispenseLetterStepPage = lazy(
  () => import("./resource/pages/StudentServices/DispenseLetterStep.tsx")
);
const AbsenceLetterStepPage = lazy(
  () => import("./resource/pages/StudentServices/AbsenceLetterStep.tsx")
);
const TheaterRoomStepPage = lazy(
  () => import("./resource/pages/StudentServices/TheaterRoomStep.tsx")
);
const BorrowRoomStepPage = lazy(
  () => import("./resource/pages/StudentServices/BorrowRoomStep.tsx")
);
const DiplomaPage = lazy(
  () => import("./resource/pages/StudyProgram/Diploma/Index.tsx")
);
const DetailDiplomaPage = lazy(
  () => import("./resource/pages/StudyProgram/Diploma/Detail.tsx")
);
const PharmacistPage = lazy(
  () => import("./resource/pages/StudyProgram/Pharmacist/Index.tsx")
);
const DetailPharmacistPage = lazy(
  () => import("./resource/pages/StudyProgram/Pharmacist/Detail.tsx")
);
const BachelorPharmacyPage = lazy(
  () => import("./resource/pages/StudyProgram/BachelorPharmacy/Index.tsx")
);
const DetailBachelorPharmacyPage = lazy(
  () => import("./resource/pages/StudyProgram/BachelorPharmacy/Detail.tsx")
);
const BachelorClinicalPage = lazy(
  () => import("./resource/pages/StudyProgram/BachelorClinical/Index.tsx")
);
const DetailBachelorClinicalPage = lazy(
  () => import("./resource/pages/StudyProgram/BachelorClinical/Detail.tsx")
);
const StudyCostPage = lazy(() => import("./resource/pages/StudyCost.tsx"));
const SatisfactionSurveyPage = lazy(
  () => import("./resource/pages/SatisfactionSurvey.tsx")
);
const AccreditationPage = lazy(
  () => import("./resource/pages/Accreditation.tsx")
);
const AccreditationCriteriaDetailPage = lazy(
  () => import("./resource/pages/AccreditationCriteriaDetail.tsx")
);
const PartnerPage = lazy(() => import("./resource/pages/Partner.tsx"));
const DynamicPage = lazy(() => import("./resource/pages/DynamicPage.tsx"));

function App() {
  return (
    <Router>
      <Suspense fallback={<LoadPage></LoadPage>}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/visi-misi" element={<ValuePage />} />
          <Route path="/dosen" element={<LecturerPage />} />
          <Route path="/sejarah" element={<HistoryPage />} />
          <Route path="/tendik" element={<StaffPage />} />
          <Route
            path="/struktur-organisasi"
            element={<OrgantizationalStructurePage />}
          />
          <Route path="/pimpinan-fakultas" element={<FaculityLeaderPage />} />
          <Route path="/zona-integritas" element={<IntegrityZone />} />
          <Route path="/wbs" element={<WBSPage />} />
          <Route path="/penelitian" element={<ResearchPage />} />
          <Route path="/buku-dan-riset" element={<BooksPage />} />
          <Route path="/pengabdian" element={<DevotionPage />} />
          <Route path="/alumni" element={<AlumniPage />} />
          <Route
            path="/alumni-berprestasi"
            element={<AlumniAchievementPage />}
          />
          <Route
            path="/alumni-berprestasi/detail/:id"
            element={<DetailAlumniAchievementPage />}
          />
          <Route path="/lowongan-kerja" element={<JobVacancyPage />} />
          <Route
            path="/lowongan-kerja/detail/:id"
            element={<DetailJobVacancyPage />}
          />
          <Route path="/kalender-akademik" element={<AcademicCalendarPage />} />
          <Route
            path="/kalender-akademik/:slug"
            element={<DetailAcademicCalendarPage />}
          />
          <Route path="/biaya-pendidikan" element={<StudyCostPage />} />
          <Route path="/kepk" element={<KEPKInformationPage />} />
          <Route
            path="/tentang-penjamin-mutu-fakultas"
            element={<AboutFacultyQualityPage />}
          />
          <Route path="/rapat-tinjauan-manajemen" element={<RTMPage />} />
          <Route
            path="/laporan-audit-mutu-internal"
            element={<InternalAuditQualityPage />}
          />
          <Route
            path="/kriteria-data-akreditasi"
            element={<AccreditationCriteriaPage />}
          />
          <Route path="/content/ruang-teater" element={<TheaterRoomPage />} />
          <Route path="/content/mushola" element={<MosquePage />} />
          <Route
            path="/content/smart-classroom"
            element={<SmartClassroomPage />}
          />
          <Route path="/content/perpustakaan" element={<LibraryPage />} />
          <Route
            path="/content/ruang-kuliah-farmasi"
            element={<FarmacyStudyRoomPage />}
          />
          <Route path="/berita" element={<NewsPage />} />
          <Route path="/berita/detail/:slug" element={<DetailNewsPage />} />
          <Route path="/pengumuman" element={<AnnouncementPage />} />
          <Route
            path="/pengumuman/detail/:slug"
            element={<DetailAnnouncementPage />}
          />
          <Route path="/agenda" element={<AgendaPage />} />
          <Route path="/galeri" element={<GalleryPage />} />
          <Route path="/acara" element={<ProgramPage />} />
          <Route path="/acara/detail/:slug" element={<DetailProgramPage />} />
          <Route path="/perpustakaan" element={<LibraryInfoPage />} />
          <Route
            path="/ppid/informasi-wajib-berkala"
            element={<ObligatoryInfoPage />}
          />
          <Route
            path="/ppid/informasi-tersedia-setiap-saat"
            element={<AvailableInfoPage />}
          />
          <Route
            path="/ppid/informasi-yang-dikecualikan"
            element={<ExcludedInfoPage />}
          />
          <Route
            path="/ppid/informasi-diumumkan-serta-merta"
            element={<NecessarilyInfoPage />}
          />
          <Route path="/informasi-regulasi" element={<RegulationInfoPage />} />
          <Route
            path="/survey-kepuasan-civitas"
            element={<SatisfactionSurveyPage />}
          />
          <Route path="/content/beasiswa" element={<SchoolarshipPage />} />

          <Route
            path="/content/bimbingan-konseling"
            element={<CounselingPage />}
          />
          <Route path="/prestasi-mahasiswa" element={<AchievementPage />} />
          <Route path="/mitra-kerjasama" element={<PartnerPage />} />
          <Route
            path="/content/layanan-mahasiswa"
            element={<StudentServicePage />}
          />
          <Route path="/layanan-pegawai" element={<EmployeeServicePage />} />
          {/* <Route
            path="/content/surat-rekomendasi-beasiswa"
            element={<ScholarshipStepPage />}
          />
          <Route
            path="/content/skl-dan-sertifikat-ukom-d3-dan-s1-farmasi-umum"
            element={<SKLGeneralStepPage />}
          />
          <Route
            path="/content/surat-aktif-kuliah"
            element={<ActiveStudyStepPage />}
          />

          <Route
            path="/content/skl-dan-sertifikat-ukom-profesi-apoteker-dan-s1-farmasi-klinik"
            element={<SKLClinicStepPage />}
          />
          <Route
            path="/content/transkrip-sementara-khs-surat-keterangan-alumni-fakultas-farmasi-unmul-form-bebas-administrasi"
            element={<TranscriptStepPage />}
          />
          <Route
            path="/content/surat-keterangan-sedang-menyelesaikan-tugas-akhir"
            element={<StudyLetterStepPage />}
          />
          <Route
            path="/content/surat-dispensasi"
            element={<DispenseLetterStepPage />}
          />
          <Route
            path="/content/surat-cuti"
            element={<AbsenceLetterStepPage />}
          />
          <Route
            path="/content/peminjaman-ruangan-untuk-sidang"
            element={<BorrowRoomStepPage />}
          />
          <Route
            path="/content/peminjaman-teater-farmasi-unmul-untuk-kegiatan"
            element={<TheaterRoomStepPage />}
          /> */}

          {/* Spesifik prodi */}
          <Route path="/prodi/diploma" element={<DiplomaPage />} />
          <Route path="/prodi/s1-farmasi" element={<BachelorPharmacyPage />} />
          <Route path="/prodi/profesi-apoteker" element={<PharmacistPage />} />
          <Route
            path="/prodi/s1-farmasi-klinis"
            element={<BachelorClinicalPage />}
          />
          <Route path="/prodi/diploma/:slug" element={<DetailDiplomaPage />} />
          <Route
            path="/prodi/s1-farmasi/:slug"
            element={<DetailBachelorPharmacyPage />}
          />
          <Route
            path="/prodi/profesi-apoteker/:slug"
            element={<DetailPharmacistPage />}
          />
          <Route
            path="/prodi/s1-farmasi-klinis/:slug"
            element={<DetailBachelorClinicalPage />}
          />

          {/* Dynamic fallback untuk prodi */}
          <Route
            path="/prodi/:slugProdi/:slugHalaman"
            element={<DynamicPage />}
          />

          {/* Dynamic fallback untuk root */}
          <Route path="/:slug" element={<DynamicPage />} />

          {/* Laboratorium */}
          <Route
            path="/content/laboratorium-farmakognosi--kimia-medisinal"
            element={
              <Laboratorium
                id="1"
                title="Laboratorium Farmakognosi & Kimia Medisinal"
                title_en="Pharmacognosy & Medicinal Chemistry Laboratory"
                url="content/laboratorium-farmakognosi--kimia-medisinal"
              />
            }
          />
          <Route
            path="/content/laboratorium-farmasetika"
            element={
              <Laboratorium
                id="2"
                title="Laboratorium Farmasetika"
                title_en="Pharmaceutics Laboratory"
                url="content/laboratorium-farmasetika"
              />
            }
          />
          <Route
            path="/content/laboratorium-farmakologi"
            element={
              <Laboratorium
                id="3"
                title="Laboratorium Farmakologi"
                title_en="Pharmacology Laboratory"
                url="content/laboratorium-farmakologi"
              />
            }
          />
          <Route
            path="/content/laboratorium-farmasi-klinik-dan-komunitas"
            element={
              <Laboratorium
                id="4"
                title="Laboratorium Farmasi Klinik dan Komunitas"
                title_en="Clinical and Community Pharmacy Laboratory"
                url="content/laboratorium-farmasi-klinik-dan-komunitas"
              />
            }
          />
          <Route
            path="/content/laboratorium-umum-pendidikan-penelitian-kefarmasian"
            element={
              <Laboratorium
                id="5"
                title="Laboratorium Umum Pendidikan Penelitian Kefarmasian"
                title_en="General Pharmaceutical Education and Research Laboratory"
                url="content/laboratorium-umum-pendidikan-penelitian-kefarmasian"
              />
            }
          />
          <Route
            path="/content/laboratorium-praktek-kerja-kefarmasian"
            element={
              <Laboratorium
                id="6"
                title="Laboratorium Praktek Kerja Kefarmasian"
                title_en="Pharmaceutical Internship Laboratory"
                url="content/laboratorium-praktek-kerja-kefarmasian"
              />
            }
          />

          <Route path="/akreditasi" element={<AccreditationPage />} />
          <Route
            path="/content/kriteria/:id"
            element={<AccreditationCriteriaDetailPage />}
          />

          {/* Dynamic fallback untuk custom */}
          <Route path="/custom/:slug" element={<DynamicPage />} />
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
